"use strict";

exports.__esModule = true;
exports.useCustomValidity = useCustomValidity;

var _react = require("react");

function useCustomValidity(ref, validationMessage) {
  if (validationMessage === void 0) {
    validationMessage = '';
  }

  (0, _react.useEffect)(function () {
    if (ref.current) {
      ref.current.setCustomValidity(validationMessage);

      if (ref.current.validity.customError) {
        ref.current.reportValidity();
      }
    }
  }, [ref, validationMessage]);
}